<template>
  <div
    class="input-component"
    :class="[
      {
        'read-only-input-disabled-movement': attrs.readonly && !modelValue,
        'input-component-without-clear-button': hideClearButton,
      },
      attrs.class,
    ]">
    <label :for="'input' + id"
      >{{ attrs.placeholder }}<template v-if="errorMessage">- {{ errorMessage }}</template></label
    >
    <input :type="inputType" placeholder=" " :id="'input' + id" v-model="val" v-bind="attrs" ref="inputComponent" />

    <div
      class="clear-input"
      v-if="!attrs.readonly && !hideClearButton"
      :class="{ show: modelValue }"
      @click="clearModelValue"></div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, useAttrs } from 'vue';
const attrs = useAttrs();
defineOptions({
  inheritAttrs: false,
});
const inputComponent = ref<HTMLInputElement | null>(null);

withDefaults(
  defineProps<{
    inputType?: string;
    errorMessage?: string;
    hideClearButton?: boolean;
  }>(),
  {
    inputType: 'text',
  }
);

const val = defineModel();

const id = Math.random().toString(36).slice(2);

onMounted(() => {
  if (attrs['auto-focus']) {
    inputComponent.value?.focus();
  }
});

function clearModelValue() {
  val.value = '';
}

function focusInput() {
  inputComponent.value?.focus();
}

defineExpose({ focusInput });
</script>
